import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop — Force scroll restoration to the top of the page on every
 * route change. Without this, React Router preserves the previous scroll
 * position when navigating between pages (e.g. clicking the "Coaching"
 * offer card at the bottom of /offre would land the user at the bottom
 * of /prsnl).
 *
 * Render once near the top of <BrowserRouter>, before the <Routes>.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // Respect in-page anchors (e.g. /prsnl#pricing) — let the browser handle them.
    if (hash) return;
    // Use 'auto' (instant) — smooth would feel laggy on cross-page transitions.
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname, hash]);

  return null;
}
